
<template>
  <IndexClients></IndexClients>
</template>

<script>

export default {
  name: 'Clients',
  components: {
    IndexClients: () => import('@/_backoffice/_registrations/components/client/IndexClients.vue'),
  },
}
</script>
